import {Injectable, inject} from '@angular/core'
import {type Observable, map} from 'rxjs'
import {SessionService} from '@uve-solutions/composition/session'
import type {IApiService} from '@uve-solutions/f-chat/core'
import {ApiService} from '../../services/api.service'

@Injectable({providedIn: 'root'})
export class ChatApiAdapter implements IApiService {
  readonly #apiService = inject(ApiService)
  readonly #sessionService = inject(SessionService)

  get<T>(url: string, httpParams: unknown): Observable<T> {
    return this.#apiService.get(url, httpParams).pipe(map(res => res as T))
  }
  post<T>(url: string, data: unknown, httpParams?: unknown): Observable<T> {
    return this.#apiService.post(url, data, httpParams).pipe(map(res => res as T))
  }
  put<T>(url: string, data?: unknown): Observable<T> {
    return this.#apiService.put(url, data).pipe(map(res => res as T))
  }
  sessionToken(): string | null {
    return this.#sessionService.currentToken()
  }
}
